<p-toast></p-toast>
<div class="mi-survey-container">
    <p-card styleClass="p-card-shadow">
        <div class="card dashboardTable">
            <p-table #miSurvey [value]="miSurveyData" [(selection)]="filteredDataForExport" dataKey="AppId_ProgID"
                (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
                [paginator]="true" [globalFilterFields]="[
                'Scheme_Specific_Id',
                'Farmer_Name_In_English',
                'Full_Name_in_Recognized_Official_Language', 
                'Gender',
                'Address_Line_1',
                'Address_Line_2',
                'Address_Line_3',
                'District',
                'State', 
                'Country', 
                'Farmer_Bank_Name', 
                'Farmer_IFSCCode',
                'Farmer_Account_Number', 
                'Aadhar_Number', 
                'Pincode',  
                'Refund_To_Farmer', 
                ]" responsiveLayout="scroll" [rowHover]="true" currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true" [paginator]="true" [rows]="10" [selectionPageOnly]="true" [rowsPerPageOptions]="[10,25,50,100]" [loading]="loading">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'FARMER_APPLICATION_FOR_MI_REFUND_TO_FARMER_LOT'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="">{{'VIEW_APPLICATION'| translate}}</th>
                        <th pSortableColumn="Farmer_Name_In_English">{{'FULL_NAME_IN_ENGLISH'| translate}}
                            <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                            <p-sortIcon field="AppID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Full_Name_in_Recognized_Official_Language">{{'FULL_NAME_RECOGNIZED'| translate}}
                            <p-columnFilter type="text" field="Full_Name_in_Recognized_Official_Language"
                                display="menu"></p-columnFilter>
                            <p-sortIcon field="Full_Name_in_Recognized_Official_Language"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Gender">{{'GENDER'| translate}}
                            <p-columnFilter type="text" field="Gender" display="menu"></p-columnFilter>
                            <p-sortIcon field="Gender"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Address_Line_1">{{'ADDRESS_LINE_1'| translate}}
                            <p-columnFilter type="text" field="Address_Line_1" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_1"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Address_Line_2">{{'ADDRESS_LINE_2'| translate}}
                            <p-columnFilter type="text" field="Address_Line_2" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_2"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Address_Line_3">{{'ADDRESS_LINE_3'| translate}}
                            <p-columnFilter type="text" field="Address_Line_3" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_3"></p-sortIcon>
                        </th>
                        <th pSortableColumn="District">{{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>
                        <th pSortableColumn="State">{{'STATE'| translate}}
                            <p-columnFilter type="text" field="State" display="menu"></p-columnFilter>
                            <p-sortIcon field="State"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Country">{{'COUNTRY'| translate}}
                            <p-columnFilter type="text" field="Country" display="menu"></p-columnFilter>
                            <p-sortIcon field="Country"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Farmer_Bank_Name">{{'FARMER_BANK_NAME'| translate}}
                            <p-columnFilter type="text" field="Farmer_Bank_Name" display="menu"></p-columnFilter>
                            <p-sortIcon field="Farmer_Bank_Name"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Farmer_IFSCCode">{{'FARMER_IFSC_CODE'| translate}}
                            <p-columnFilter type="text" field="Farmer_IFSCCode" display="menu"></p-columnFilter>
                            <p-sortIcon field="PrograFarmer_IFSCCodemmeName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Farmer_Account_Number">{{'FAMER_ACCOUNT_NUMBER'| translate}}
                            <p-columnFilter type="text" field="Farmer_Account_Number" display="menu"></p-columnFilter>
                            <p-sortIcon field="Farmer_Account_Number"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Aadhar_Number">{{'AADHAR_NUMBER'| translate}}
                            <p-columnFilter type="text" field="Aadhar_Number" display="menu"></p-columnFilter>
                            <p-sortIcon field="Aadhar_Number"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Pincode">{{'PINCODE'| translate}}
                            <p-columnFilter type="text" field="Pincode" display="menu"></p-columnFilter>
                            <p-sortIcon field="Pincode"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Scheme_Specific_Id">{{'SCHEME_SPECIFIC_ID'| translate}}
                            <p-columnFilter type="text" field="Scheme_Specific_Id" display="menu"></p-columnFilter>
                            <p-sortIcon field="Scheme_Specific_Id"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Refund_To_Farmer">{{'REFUND_TO_FARMER'| translate}}
                            <p-columnFilter type="text" field="Refund_To_Farmer" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Refund_To_Farmer"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="product"></p-tableCheckbox>
                        </td>
                        <td>
                            <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                class="p-button-rounded p-button-accent mr-1 btnSize"
                                (click)="selectFarmerApplication(product)"></button>
                        </td>
                        <td>{{product.Farmer_Name_In_English}}</td>
                        <td>{{product.Full_Name_in_Recognized_Official_Language}}</td>
                        <td>{{product.Gender}}</td>
                        <td>{{product.Address_Line_1}}</td>
                        <td>{{product.Address_Line_2}}</td>
                        <td>{{product.Address_Line_3}}</td>
                        <td>{{product.District}}</td>
                        <td>{{product.State}}</td>
                        <td>{{product.Country}}</td>
                        <td>{{product.Farmer_Bank_Name}}</td>
                        <td>{{product.Farmer_IFSCCode}}</td>
                        <td>{{product.Farmer_Account_Number}}</td>
                        <td>{{product.Aadhar_Number}}</td>
                        <td>{{product.Pincode}}</td>
                        <td>{{product.Scheme_Specific_Id}}</td>
                        <td>{{product.Refund_To_Farmer}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{miSurveyData ? miSurveyData.length : 0 }} {{'REFUND_TO_FARMER_LOT'| translate}}
                    </div>
                </ng-template>
            </p-table>
        </div>
        <div class="card" *ngIf="filteredData.length">
            <h5><b>{{'TOTAL_NO_OF_APPLICATION_FILTERED_REFUND'| translate}}: {{ totalSelectedApp }}</b></h5>

            <div class="flex justify-content-end">
                <button (click)="menu.toggle($event)" pButton pRipple p-button-info label="Download Filtered Lot Data"
                    icon="pi pi-upload"></button>
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </div>

            <div class="card">
                <p-toolbar *ngIf="filteredData.length">
                    <ng-template pTemplate="left">

                    </ng-template>
                    <ng-template pTemplate="right">
                        <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status" class="mr-3">
                        </p-dropdown>
                        <textarea id="description" [(ngModel)]="remarks" placeholder="Remarks" pInputTextarea required
                            rows="3" cols="20" class="mr-3"></textarea>
                        <button pButton pRipple label=" {{'SUBMIT'| translate}}" (click)="handleClick()" class="p-button-help"></button>
                    </ng-template>
                </p-toolbar>
            </div>
        </div>

    </p-card>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>